import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { color, boxShadow, boxShadowActive } from '../globalStyles'
import { Absolute } from './common'
import BackgroundImage from './BackgroundImage'
import Flickity from './Flickity'

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  pointer-events: none;
  background-image: linear-gradient(
    0deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
`
const Slider = styled(Flickity)`
  height: 100%;
  background: ${color.lightGrey};

  .flickity-page-dots {
    bottom: 1rem;
    right: 1rem;
    text-align: right;
    z-index: 1;
    color: white;

    .dot {
      background: currentColor;
      box-shadow: ${boxShadow};

      &:hover {
        transform: translateY(-1px);
        box-shadow: ${boxShadowActive};
      }
    }
  }
  .flickity-prev-next-button {
    background: none;
    color: white;
    height: 4rem;

    &:hover,
    &:focus {
      background: none;
    }

    .arrow {
      fill: currentColor;
    }
  }
`
const SlideImage = styled(BackgroundImage)`
  height: 100%;
  width: 100%;
  margin: 0 1rem;
`

class ImageFader extends Component {
  static defaultProps = {
    fadeTime: 5000
  }

  state = {
    activeImage: 0
  }

  fader = null

  componentDidMount () {
    this.startFader()
  }

  componentWillUnmount () {
    this.destroyFader()
  }

  startFader () {
    if (!this.props.images.length > 1) return
    this.fader = setInterval(() => {
      let activeImage = this.state.activeImage + 1
      if (!this.props.images[activeImage]) activeImage = 0
      this.setState({
        activeImage: activeImage
      })
    }, this.props.fadeTime)
  }

  destroyFader () {
    clearInterval(this.fader)
  }

  render () {
    const { slider = false, images } = this.props
    return (
      <Absolute>
        {slider && images.length > 1 ? (
          <Slider
            options={{
              prevNextButtons: true,
              wrapAround: false,
              autoPlay: 7000,
              bgLazyLoad: 1,
              resize: true,
              arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 65,
                y2: 45,
                x3: 20
              }
            }}
          >
            {images.map((image, index) => (
              <SlideImage
                key={`ImageFader--Slide-${index}`}
                data-flickity-bg-lazyload={image}
              />
            ))}
          </Slider>
        ) : (
          <Fragment>
            {images.map((image, index) => (
              <BackgroundImage
                key={`ImageFader--Slide-${index}`}
                image={image}
                opacity={index === this.state.activeImage ? '1' : '0'}
                noSpinner
              />
            ))}
            <Overlay />
          </Fragment>
        )}
      </Absolute>
    )
  }
}

ImageFader.propTypes = {
  images: PropTypes.array.isRequired
}

export default ImageFader



// WEBPACK FOOTER //
// ./src/components/ImageFader.js